var _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrDivider = function SvgOrDivider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 14"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: "50%",
    fill: "currentColor",
    dominantBaseline: "central",
    fontFamily: "Times New Roman",
    fontSize: 20,
    textAnchor: "middle"
  }, "OR")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M100 5.5v3L150 7zM0 7l50-1.5v3z"
  })));
};
export default SvgOrDivider;